/** http(s) only — drop javascript: and other schemes. */
export function safeMediaUrl(value) {
  const s = String(value || '').trim()
  if (!/^https?:\/\//i.test(s)) return ''
  return s
}

function hostLabel(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}

/** Article link and image returned with a GreenID adverse-media hit. */
export default function AmlMediaSource({ match, compact = false }) {
  if (!match) return null
  const url = safeMediaUrl(match.mediaUrl)
  const image = safeMediaUrl(match.mediaImage)
  const snippet = String(match.mediaSnippet || '').trim()
  if (!url && !image && !snippet) return null

  return (
    <div className={compact ? 'mt-2 space-y-1.5' : 'mt-3 space-y-2'}>
      {image && (
        <a href={url || image} target="_blank" rel="noopener noreferrer" className="inline-block">
          <img
            src={image}
            alt=""
            referrerPolicy="no-referrer"
            className={`rounded border border-gray-200 object-cover bg-white ${compact ? 'max-h-24 max-w-full' : 'max-h-48 max-w-full'}`}
          />
        </a>
      )}
      {snippet && !compact && (
        <p className="text-sm text-gray-700">{snippet}</p>
      )}
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-sm font-medium text-primary-700 hover:underline break-all"
        >
          {compact ? hostLabel(url) : url}
        </a>
      )}
    </div>
  )
}
